import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TabsModule } from 'primeng/tabs';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';

@Component({
  selector: 'app-formly-document-postal-addresses-widget',
  templateUrl: './formly-document-postal-addresses-widget.component.html',
  styleUrls: ['./formly-document-postal-addresses-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TabsModule,
    FormlyModule,
    ScrollPanelModule
  ]
})
export class FormlyDocumentPostalAddressesWidgetComponent extends FieldType<FieldTypeConfig> {

  constructor(
    private i18n: I18nService
  ) {
    super();
  }

  getTabTitle(index: number): string {
    let tab = this.field.fieldGroup[index];
    if (tab?.props?.translate)
      return this.i18n.translate(tab.props?.label);
    else
      return tab.props?.label;
  }

  /**
   * Checks if any field in the postal address has a value
   * Only applies to: documentPostalAddress (Beleganschrift), deliveryPostalAddress (Lieferanschrift),
   * and invoiceReceiverPostalAddress (Rech. Anschrift)
   */
  hasPostalAddressContent(index: number): boolean {
    const field = this.field.fieldGroup[index];
    const fieldKey = field?.key as string;

    // Only apply to these three specific tabs
    const allowedKeys = [
      'deliveryPostalAddress',
      'invoiceReceiverPostalAddress',
      'initiatorPostalAddress'
    ];
    if (!allowedKeys.includes(fieldKey)) {
      return false;
    }

    // Read from formControl.value instead of field.model[fieldKey] to get real-time data
    // field.model[fieldKey] can be stale due to OnPush change detection timing
    const postalAddress = field?.formControl?.value;

    if (!postalAddress) return false;

    const fieldsToCheck = [
      'recipient', 'addition', 'addition2', 'addition3',
      'street', 'streetNumber', 'countryIso', 'state',
      'postalCode', 'city', 'phone', 'email', 'vatId', 'taxId'
    ];

    // Only include postalAddressType for deliveryPostalAddress (user-editable), not for invoiceReceiverPostalAddress
    if (fieldKey === 'deliveryPostalAddress') {
      fieldsToCheck.push('postalAddressType');
    }

    return fieldsToCheck.some(key => postalAddress[key]?.toString().trim());
  }
}
